// extracted by mini-css-extract-plugin
export default {"container":"user_container__-ZXru","tableLight":"user_tableLight__HeJ5K","tableDark":"user_tableDark__r79lg"};